import { day, hasValue, toTitleCase } from '@vrplatform/utils';
import type { change, syncSubtask } from '@vrplatform/graphql';
import { getListingName } from '@vrplatform/ui-common';
import { undefined } from 'zod';
import type { WorkflowChange } from './_types';

export const getSubtask = (subtask: syncSubtask): WorkflowChange => {
  return {
    id: subtask.id,
    type: 'Subtask',
    createdAt: subtask.createdAt,
    status: subtask.status,
    syncSubtaskRef: subtask.triggerRef,
    message: subtask.message || '',
    title: toTitleCase(subtask.status) || '',
    automationId: null,
    externalHref: '',
    inputJson: undefined,
    outputJson: undefined,
    date: null,
    uniqueRef: '',
    links: {
      paymentIds: [],
      reservationIds: [],
    },
  };
};

export const getWorkflowChangeRow = (
  change: change,
  type: 'synced-from' | 'synced-to'
): WorkflowChange => {
  const source = change.source;

  const reservation = {
    id: change.reservation?.id,
    title: change.reservation?.guestName,
  };

  const payment = {
    id: source?.payment?.id,
    title: source?.payment?.uniqueRef,
  };

  const listing = {
    id: source?.listing?.id,
    title: getListingName(source?.listing, { allowEmpty: true }),
  };

  const syncedFromTitle = [
    toTitleCase(change.source?.type),
    change.source?.description || change.entityUniqueRef,
  ]
    .filter(hasValue)
    .join(' - ');

  const syncedToTitle =
    reservation.title || payment.title || listing.title || syncedFromTitle;

  const title = type === 'synced-from' ? syncedFromTitle : syncedToTitle;

  return {
    id: change.id,
    createdAt: change.createdAt,
    status: change.status,
    syncSubtaskRef: change.syncSubtask?.triggerRef,
    message: change.message || '',
    title,
    type: toTitleCase(change.entityType),
    date: day(change.message).isValid() ? day(change.message).yyyymmdd() : '',
    uniqueRef: change.entityUniqueRef,
    automationId: change.automationId,
    inputJson: undefined,
    outputJson: undefined,
    externalHref: change.source?.dataHref,
    links: {
      paymentIds: [payment].filter((x) => !!x.id) as any[],
      reservationIds: [reservation].filter((x) => !!x.id) as any[],
    },
  };
};
